module.exports = __webpack_public_path__ + "static/media/beep_warning.789de308.mp3";